// extracted by mini-css-extract-plugin
export default {"sortableItem":"wgBuMAqJw2","dragHandle":"BkH1aiMOKb"};